import _ from "lodash";

function zoneCoordinateCalc(width, height, data) {
    const originWidth = 500;
    const originHeight = 500;

    const calcWidth = width;
    const calcHeight = height;

    return _.map(data, (item, idx) => {
        let pitchPostion = JSON.parse(item['pitchPostion']);

        const x = (pitchPostion['pitchPositionX']*calcWidth/originWidth);
        const y = calcHeight - (pitchPostion['pitchPositionY']*calcHeight/originHeight);
        item['pitchX'] = x;
        item['pitchY'] = y;
        item['key'] = (item['gameInfoId']+"_"+item['batterId']+"_"+item['pitcherId']+"_"
            +item['strikes']+"_"+item['balls']+"_"+item['inning']+"_"+item['outs']+"_"+item['pitchOfPa']+"_point");
        return item;
    });
}

export default zoneCoordinateCalc;